export default {
  dashboard: "Dashboard",
  company: "Companies",
  person: "Contacts",
  invoice: "Invoices",
  product: "Products",
}
